import React from "react";
import { Modal, Button } from "@hid-galaxy-ui/galaxy-react";
import "./Modals.scss";

interface ConfirmationModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      headerText={title}
      width={500}
      onClose={onCancel}
      className="confirmation-modal"
    >
      <div className="modal-content">
        <p className="confirmation-message">{message}</p>
        <div className="modal-footer centered">
          <Button
            variant="primary"
            label={confirmLabel}
            normalCase={true}
            onClick={onConfirm}
          />
          <Button
            variant="secondary"
            label={cancelLabel}
            normalCase={true}
            onClick={onCancel}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;

